import { Box, Button, Divider, IconButton, Modal } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface StatusChangeWarningProps {
    isVisible: boolean;
    handleOk: () => Promise<void>;
    handleCancel: () => Promise<void>;
    toStatus: string | null;
    appName: string | null;
}

const StatusChangeWarning = ({ isVisible, handleCancel, handleOk, toStatus, appName }: StatusChangeWarningProps) => {
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '840px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <Modal
            open={isVisible}
            onClose={handleCancel}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={modalStyle}>
                <IconButton
                    aria-label="close"
                    onClick={handleCancel}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                {toStatus === "Confirm Cutover" ?
                    <div>
                        <div className="details-apps-header">Confirm Cutover</div>
                        <br/>
                        <Divider></Divider>
                        <br/>
                        <p>
                            By selecting "Confirm Cutover", you acknowledge and agree to the following:<br />
                            <br/>
                            <b>1) Configuration Validation:</b> You confirm that the application configuration has been successfully tested and validated.<br />
                            <b>2) Cutover Approval:</b> You approve the cutover to proceed as planned.<br />
                            <b>3) Hypercare Period:</b> Upon confirmation, a two-week hypercare period will commence immediately. During this time, support will be available to address any post-cutover issues.<br />
                            <b>4) Endpoint Deactivation:</b> At the conclusion of the hypercare period, the application endpoint in PwC Identity (ForgeRock) will be disabled.
                        </p>
                        <br />
                        <Button style={{ margin: '10px', float: 'right', width: '150px', textTransform: 'none', backgroundColor: '#FD5107' }} variant="contained" color="success" onClick={handleOk}>Confirm Cutover</Button>
                        <Button style={{ margin: '10px', float: 'right', width: '100px', textTransform: 'none', backgroundColor: 'white', color: '#FD5107', borderColor: '#FD5107', borderStyle: 'solid', borderWidth: '10' }} variant="outlined" color="warning" onClick={handleCancel}>Cancel</Button>
                    </div>
                    : ''
                }
                {toStatus === "Complete"
                    ? 
                    <div>
                        <div className="details-apps-header">Confirm completion</div>
                        <br/>
                        <Divider></Divider>
                        <br/>
                        <p>
                            By selecting "Complete" you acknowledge and agree to the following:<br />
                            <br/>
                            <b>1) Confirmation of Hypercare Completion:</b> Confirm that outstanding issues (if any) from the 2-week hypercare period have been resolved.<br />
                            <b>2) Disable Endpoint:</b> The application endpoint in PwC Identity (ForgeRock) has been deactivated after the hypercare period.<br />
                            <b>3) Acknowledgment of Migration Success:</b> By confirming, you acknowledge that the migration to Microsoft Entra ID is successful and complete; No further action is required.
                        </p>
                        <br />
                        <Button style={{ margin: '10px', float: 'right', width: '180px', textTransform: 'none', backgroundColor: '#FD5107' }} variant="contained" color="success" onClick={handleOk}>Confirm completion</Button>
                        <Button style={{ margin: '10px', float: 'right', width: '100px', textTransform: 'none', backgroundColor: 'white', color: '#FD5107', borderColor: '#FD5107', borderStyle: 'solid', borderWidth: '10' }} variant="outlined" color="warning" onClick={handleCancel}>Cancel</Button>
                    </div>
                    : ''}
                {toStatus === "To Be Decommissioned" || toStatus === "Decommissioned"
                    ?
                    <div>
                        <div className="details-apps-header">Confirm App Decommissioning</div>
                        <br/>
                        <Divider></Divider>
                        <br/>
                        <p>
                            Are you sure you want to decommission { appName } app?<br/>
                            <br/>
                            <b>Key Points:</b><br/>
                            <ul>
                                <li style={{ marginLeft: '30px' }}>This app will not be migrated to the new environment (Entra ID).</li>
                                <li style={{ marginLeft: '30px' }}>Decommissioning is a permanent action.</li>
                            </ul>
                            <br/>
                            <b>To continue, you will be directed to the Service Now portal to create a support ticket for this request.</b>
                            <br />
                            Guide to decommision an application <a href="https://migration.idaas.pwc.com/docs/migration-activities/application-decom">link</a>
                            
                        </p>
                        <br />
                        <Button style={{ margin: '10px', float: 'right', width: '220px', textTransform: 'none', backgroundColor: '#C52A1A' }} variant="contained" color="success" onClick={handleOk}>Proceed to Decommission</Button>
                        <Button style={{ margin: '10px', float: 'right', width: '100px', textTransform: 'none', backgroundColor: 'white', color: '#FD5107', borderColor: '#FD5107', borderStyle: 'solid', borderWidth: '10' }} variant="outlined" color="warning" onClick={handleCancel}>Cancel</Button>
                    </div>
                    : ''}
                <br/>
                <br/>
            </Box>
        </Modal>
    );
};

export default StatusChangeWarning;